import React from "react";
import { Container, Col, Row, Image } from "react-bootstrap";
import { Breadcrumbs, Link, Typography } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import "../../../Assets/css/mjstatic.css";
import Button from "@mui/material/Button";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { client_name, ImageUrl, Je_welryspelling } from "../../../Helpers/request";
import CustomeServicesGif from "../../../Assets/images/service-gif.gif";

const CustomServices = () => {
  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaDetails.title}</title>
        <meta name="description" content={metaDetails.description}></meta>
        <meta name="keywords" content={metaDetails.keywords}></meta>
        {/* <link rel="canonical" href="https://hemmingjewelers.com/our-story" /> */}
      </Helmet>
      <div className="rcs_ringsetting_section mt-3">
        <Container>
          <Row>
            <Col className="rcs_breadcrumb m-0 mb-md-5">
              <Breadcrumbs aria-label="breadcrumb">
                <Link underline="hover" color="inherit" href="/">
                  Home
                </Link>
                <Typography color="text.primary">Custom Services</Typography>
              </Breadcrumbs>
            </Col>
          </Row>
          {/* <Row className="m-auto w-100">
            <div className="rcs_story_content">
              <h1>Custom Designed Jewelry</h1>
              <h2>OFFERING IN-HOUSE JEWELRY DESIGNERS & DIAMOND SPECIALISTS</h2>
              <p>Whether you’re entrusting us to craft a new engagement ring, or have an heirloom that’s been handed down and needs updating, we are the most trusted source for custom jewelry in The Bay Area. Our artisans/engineers will help you translate your ideas into beautiful works of art, then our master jewelers will assemble a one-of-a-kind piece for you. With our vast selection of large diamonds and rare gemstones, your new or updated piece will be a show-stopper. In fact, we will make the entire process incredibly fun and rewarding. We don’t want to just fulfill your expectations, that’s too easy — we want to surpass them!</p>

            </div>
          </Row> */}
          <Container>
            <Row>
              <Col xs={12} className="mb-1 text-center">
                <div className="pageH1Main custom"> <h1> Professional Jewelry Repair Services in San Jose </h1></div>
              </Col>
            </Row>
          </Container>
          <div className="rcs_story_content mt-3 mb-3">


            <Row className="m-auto w-100">
              <Col md={6} xs={12} className="p-0 d-flex align-items-center order-2 oeder-md-1 order-lg-1">
                <div className="rcs_story_content">
                  <h1>Custom Designed Jewelry</h1>
                  <h2>OFFERING IN-HOUSE JEWELRY DESIGNERS & DIAMOND SPECIALISTS</h2>
                  <p>Whether you’re entrusting us to craft a new engagement ring, or have an heirloom that’s been handed down and needs updating, we are the most trusted source for custom jewelry in The Bay Area. Our artisans/engineers will help you translate your ideas into beautiful works of art, then our master jewelers will assemble a one-of-a-kind piece for you. With our vast selection of large diamonds and rare gemstones, your new or updated piece will be a show-stopper. In fact, we will make the entire process incredibly fun and rewarding. We don’t want to just fulfill your expectations, that’s too easy — we want to surpass them!</p>

                </div>
              </Col>
              <Col md={6} xs={12} className="order-1 oeder-md-2 order-lg-2">
                <div className="rcs_our_story_img_main">
                  <Image src={CustomeServicesGif} alt="Custom Services"></Image>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default CustomServices;
